import React, { useEffect, useState } from 'react';
import Form, { useForm } from '../../molecules/Form';
import Field from '../Field';
import Button from '../../molecules/Button';
import iconImg1 from '../../../assets/icon-arrow-magic.svg';
import iconImg2 from '../../../assets/icon-calendar.svg';
import { StepsFormWrap } from './CreateCompaign.styles';
import { emailLengthOption, greetOption, langOption, voiceOption } from '../../Constant';

const CampaignSettings = ({ setData, data, NextStep, goBack, step, totalStep = 5, setActiveTab }) => {
  const [form] = useForm();
  const handelSubmit = e => {
    const settingData = {
      ...e,
      greeting: e.greeting.value,
      language: e.language.value,
      voice_tone: e.voice_tone.value,
    };
    setData(prev => ({ ...prev, campaignSettings: settingData }));
    // NextStep();
    setActiveTab('signature');
  };


  useEffect(() => {
    if (data?.campaignSettings) {
      form.setFieldsValue({
        call_to_action: data?.campaignSettings?.call_to_action || '',
        // email_length_msg1: data?.campaignSettings?.email_length_msg1,
        // email_length_msg2: data?.campaignSettings?.email_length_msg2,
        // email_length_msg3: data?.campaignSettings?.email_length_msg3,
        language: langOption?.find(elem => elem?.value === data?.campaignSettings?.language),
        voice_tone: voiceOption?.find(elem => elem?.value === data?.campaignSettings?.voice_tone),
        greeting: greetOption?.find(elem => elem?.value === data?.campaignSettings?.greeting),
        email_length_msg1: emailLengthOption?.find(elem => elem?.value === data?.campaignSettings?.email_length_msg1),
        email_length_msg2: emailLengthOption?.find(elem => elem?.value === data?.campaignSettings?.email_length_msg2),
        email_length_msg3: emailLengthOption?.find(elem => elem?.value === data?.campaignSettings?.email_length_msg3),
      });
    }
  }, []);

  return (
    <>
      <StepsFormWrap>
        <Form className="form-area" form={form} onSubmit={handelSubmit}>
          <div className="content-wrap">
            <div className="head">
              <strong className="heading">Campaign Settings!</strong>
            </div>

            <div className="two-col">
              <Form.Item
                selectSm
                colorBg
                label="Voice/Tone"
                type="select"
                rounded
                name="voice_tone"
                placeholder="Set Voice Tone"
                rules={[
                  {
                    required: true,
                    message: 'Voice tone is required',
                  },
                ]}
                options={voiceOption}>
                <Field />
              </Form.Item>
              <Form.Item
                inputSm
                colorBg
                label="Call to Action"
                type="text"
                name="call_to_action"
                placeholder="Write ...."
                rules={[
                  {
                    required: true,
                    message: 'Call to action is required',
                  },
                ]}>
                <Field />
              </Form.Item>
              <Form.Item
                selectSm
                colorBg
                label="Language"
                type="select"
                rounded
                name="language"
                placeholder="Select Language"
                rules={[
                  {
                    required: true,
                    message: 'Language is required',
                  },
                ]}
                options={langOption}>
                <Field />
              </Form.Item>
              <Form.Item
                selectSm
                colorBg
                label="Greeting"
                type="select"
                rounded
                name="greeting"
                placeholder="Choose Greeting Style"
                rules={[
                  {
                    required: true,
                    message: 'Greeting is required',
                  },
                ]}
                options={greetOption}>
                <Field />
              </Form.Item>
            </div>
            <span className="col-title">Email Length</span>
            <div className="two-col">
              <Form.Item
                selectSm
                colorBg
                label="Message 1 Email Length (words)"
                type="select"
                rounded
                name="email_length_msg1"
                placeholder="select length"
                rules={[
                  {
                    required: true,
                    message: 'Message 1 length is required',
                  },
                ]}
                options={emailLengthOption}>
                <Field />
              </Form.Item>
              <Form.Item
                selectSm
                colorBg
                label="Message 2 Email Length (words)"
                type="select"
                rounded
                name="email_length_msg2"
                placeholder="select length"
                rules={[
                  {
                    required: true,
                    message: 'Message 2 length is required',
                  },
                ]}
                options={emailLengthOption}>
                <Field />
              </Form.Item>
            </div>
            <Form.Item
              selectSm
              colorBg
              label="Message 3 Email Length (words)"
              type="select"
              rounded
              name="email_length_msg3"
              placeholder="select length"
              rules={[
                {
                  required: true,
                  message: 'Message 3 length is required',
                },
              ]}
              options={emailLengthOption}>
              <Field />
            </Form.Item>
          </div>
          <div className="btn-holder">
            {/* <Button newStyle rounded variant="outline" width="155px">
              Need Help?
            </Button>
            <div className="btn-wrap">
            </div> */}
            <Button
              newStyle
              rounded
              variant="outline"
              width="155px"
              type="button"
              onClick={() => setActiveTab('offer')}>
              Back
            </Button>
            <Button newStyle rounded variant="darkBlue" type="submit" width="155px">
              Next
            </Button>
          </div>
        </Form>
      </StepsFormWrap>
    </>
  );
};

export default CampaignSettings;
